export type ContactPhone = {
  /** Spanish national format, as displayed on the site. */
  display: string;
  /** International format, used for structured data. */
  intl: string;
  /** `tel:` link. */
  href: string;
};

const phone = (display: string): ContactPhone => {
  const digits = display.replace(/\D/g, "");
  return { display, intl: `+34 ${display}`, href: `tel:+34${digits}` };
};

export const CONTACT_PHONES: ContactPhone[] = [
  phone("955 73 73 22"),
  phone("622 22 63 49"),
  phone("678 99 91 11"),
];

export const MAIN_PHONE = CONTACT_PHONES[0];
export const MADRID_PHONE = phone("910 32 72 55");

export const WHATSAPP_NUMBER = "+34 621 15 14 68";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}`;
